import React from 'react';

// import BaseLogo from './sourceImages/logo.svg';
import BaseLogo from './sourceImages/Icon.svg';

export default function Logo (params) {
    return (
        <img src={BaseLogo} alt="SocialBoterfly Logo" />
    )
    
}